import { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { SyntheticBanner } from '@/components/tcheck';
import { apiGet } from '@/lib/api';
import '@/App.css';

const Onboarding = lazy(() => import('@/pages/Onboarding'));
const Login = lazy(() => import('@/pages/Login'));
const Portal = lazy(() => import('@/pages/Portal'));
const Approval = lazy(() => import('@/pages/Approval'));
const DemoBank = lazy(() => import('@/pages/DemoBank'));
const OrgDashboard = lazy(() => import('@/pages/OrgDashboard'));
const DeveloperDocs = lazy(() => import('@/pages/DeveloperDocs'));
const Grants = lazy(() => import('@/pages/Grants'));
const VoiceFacePilot = lazy(() => import('@/pages/VoiceFacePilot'));

function useSyntheticMode(): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    void apiGet<{ synthetic_mode: boolean }>('/api/ready')
      .then((r) => setOn(!!r.synthetic_mode))
      .catch(() => setOn(false));
  }, []);
  return on;
}

export default function App() {
  const synthetic = useSyntheticMode();
  return (
    <AuthProvider>
      {synthetic && <SyntheticBanner />}
      <BrowserRouter>
        <Suspense
          fallback={<main className="grid min-h-screen place-items-center bg-[#F8F9FA] text-slate-500">Cargando…</main>}
        >
          <div className={synthetic ? 'pt-9' : ''}>
            <Routes>
              <Route path="/" element={<Navigate to="/registro" replace />} />
              <Route path="/registro" element={<Onboarding />} />
              <Route path="/ingresar" element={<Login />} />
              <Route path="/portal" element={<Portal />} />
              <Route path="/autorizaciones" element={<Grants />} />
              <Route path="/organizacion" element={<OrgDashboard />} />
              <Route path="/organizacion/integracion" element={<DeveloperDocs />} />
              <Route path="/solicitud/:transactionId" element={<Approval />} />
              <Route path="/demo-bank/*" element={<DemoBank />} />
              <Route path="/piloto-voz-rostro" element={<VoiceFacePilot />} />
              <Route path="*" element={<Navigate to="/registro" replace />} />
            </Routes>
          </div>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}
